import config from "../../../config/domain";
import GlobalStore from "../../store/globalStore";
import { ITokenObj } from "../../types/genericTypes";
import { apiService } from "../apiServices";
import servicesList from "../serviceList";
import { xhrApiService } from "../xhrApiServices";
import { decryptJwtToken } from "./encryptionNew";


function sortDocumentInfo(documents: any) {
  let sortedDocuments: Array<Object> = [];
  for (let doc of documents) {
    let docObj: any = {};
    docObj.FileName = doc.fileName;
    docObj.DocumentId = doc.documentId;
    docObj.MimeType = doc.mimeType;
    docObj.PanNo = doc.panno;
    docObj.PersonalDetailsId = doc.personaldetailsid;
    docObj.DocumentCategoryId = doc.documentCategoryId;
    docObj.DocumentExpiryDate = doc.documentexpirydate;
    docObj.IsFileCropped = doc.isfilecropped;
    docObj.IsWatsappFlag = doc.isWatsappFlag;
    docObj.DocumentNumber = doc.documentNumber || window.localStorage.getItem('documentNumber');
    docObj.AutoQc = doc.autoqc;
    docObj.IsKycDocument = doc.iskycdocument;
    docObj.isElogSignOpted = doc.isElogSignOpted;
    docObj.DocumentDate = doc.DocumentDate;
    if (doc.AutoQcWithDocumentId) {
      docObj.AutoQcWithDocumentId = doc.AutoQcWithDocumentId;
    }
    sortedDocuments.push(docObj);
  }
  return sortedDocuments;
}

export const AUploadDocument = (
  callback: CallableFunction,
  uploadObj: any,
  onProgress?: any,
  saveObj?: any,
) => {
  const docReqPayLoad: any = {
    ApplicationId: uploadObj.applicationid,
    FileName: uploadObj.filename,
    Base64Document: uploadObj.base64document,
    ClientPrimaryDetailId: saveObj?.clientPrimaryDetailId,
    LeadId: saveObj?.leadId,
    DocumentInfo: saveObj?.documentInfo
      ? sortDocumentInfo(saveObj?.documentInfo)
      : [],
    panNo: uploadObj?.panNo,
    createdBy: 0,
    ModifiedBy: uploadObj.ModifiedBy,
    entitySubType: saveObj?.entitySubType
    //UtmInfoDetails: saveObj?.objUTM_Info

  };
  if (uploadObj?.DocType !== null && uploadObj?.DocType !== undefined) {
    docReqPayLoad.DocType = uploadObj.DocType;
  }
  if (
    uploadObj?.QltyByPassFlag !== null &&
    uploadObj?.QltyByPassFlag !== undefined
  ) {
    docReqPayLoad.QltyByPassFlag = uploadObj.QltyByPassFlag;
  }
  if (
    uploadObj.filename.includes("_Photo") ||
    uploadObj.filename === "personalPhoto.jpeg"
    // || uploadObj.filename.includes("Signature")
  ) {
    docReqPayLoad.QltyByPassFlag = 1;
  }
  if (saveObj !== null && saveObj !== undefined) {
    docReqPayLoad.ClientPrimaryDetailId = saveObj?.clientPrimaryDetailId;
    docReqPayLoad.LeadId = saveObj?.leadId;
    docReqPayLoad.DocumentInfo = saveObj?.documentInfo
      ? sortDocumentInfo(saveObj?.documentInfo)
      : [];
    //  docReqPayLoad.UtmInfoDetails = saveObj?.objUTM_Info;
  }
  let userId = 0;
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = parseInt(tokenMainObj?.UserId?.toString());
  }
  docReqPayLoad.createdBy = userId;
  xhrApiService(
    {
      url: "Document/Upload",
      body: docReqPayLoad,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      isNewUrl: true,
      tempToken: config.tempToken,
      serviceName: servicesList.uploadDocumentToS3,
    },
    callback,
    onProgress
  );

  // xhrApiService(
  //     {
  //         url: 'eco/upload-document',
  //         body: uploadObj,
  //     },
  //     callback,
  //     onProgress
  // );
};

export const AGetBrokerage = (callback: CallableFunction, appID: string) => {
  apiService(
    {
      url: "BS/Get",
      body: {
        applicationId: appID,
        category: "3",
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getBrokerage,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-brokerage",
  //     body: {
  //       applicationid: appID,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AGetBrokerageDetails = (
  callback: CallableFunction,
  appID: string
) => {
  apiService(
    {
      url: "BS/Get",
      body: {
        applicationId: appID,
        category: "1",
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getBrokerageDetails,
    },
    callback
  );
  //   apiService(
  //     {
  //       url: "eco/get-brokerage-details",
  //       body: {
  //         applicationid: appID,
  //       },
  //       method: "POST",
  //     },
  //     callback
  //   );
};

export const ASaveBrokerageDetails = (
  callback: CallableFunction,
  saveObj: object
) => {
  apiService(
    {
      url: "BS/SaveBr",
      body: saveObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.saveBrokerageDetails,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/save-brokerage-details",
  //     body: saveObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};
//DP/Verification

export const ADPverification = (callback: CallableFunction,
  saveObj: any) => {
  apiService(
    {
      url: "DP/Verification",
      body: saveObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.DPverification,
    },
    callback
  );

}
export const ASaveDematDetails = (
  callback: CallableFunction,
  saveObj: any
) => {
  apiService(
    {
      url: "DP/Save",
      body: saveObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.SaveDematDetailsRes,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/save-brokerage-details",
  //     body: saveObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AGetDPDetails = (callback: CallableFunction, appID: string) => {
  apiService(
    {
      url: "DP/Get",
      body: {
        applicationId: appID,
        esigndocumenttype: 0
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getDPdetails,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/get-brokerage",
  //     body: {
  //       applicationid: appID,
  //     },
  //     method: "POST",
  //   },
  //   callback
  // );
};
export const ASaveBrokerageSegmentDetiails = (
  callback: CallableFunction,
  saveSegObj: object
) => {
  apiService(
    {
      url: "BS/SaveSe",
      body: saveSegObj,
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.saveBrokerageSegmentDetails,
    },
    callback
  );
  // apiService(
  //   {
  //     url: "eco/save-brokeragesegment-details",
  //     body: saveSegObj,
  //     method: "POST",
  //   },
  //   callback
  // );
};

export const AGetBrokerageSegmentDetails = (
  callback: CallableFunction,
  appID: string
) => {
  apiService(
    {
      url: "BS/Get",
      body: {
        applicationId: appID,
        category: "2",
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getBrokerageSegmentDetails,
    },
    callback
  );
  //   apiService(
  //     {
  //       url: "eco/get-brokeragesegment-details",
  //       body: {
  //         applicationid: appID,
  //       },
  //       method: "POST",
  //     },
  //     callback
  //   );
};

export const AGetDPName = (
  callback: CallableFunction,
  dpid: string
) => {
  apiService(
    {
      url: "MastersData/GetDPName",
      body: {
        dpid: dpid,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getBrokerageSegmentDetails,
    },
    callback
  );
};
